import {DataObjectId} from 'yougile-model'
import {UIElement} from '../ui-element'

export class InputEl extends UIElement {
  public override uiTag = 'input'
  private uiOnChange: (val: string) => void

  constructor(companyId: DataObjectId) {
    super(companyId, undefined, undefined)
  }

  public get onChange(): (val: string) => void {
    return this.uiOnChange
  }

  public set onChange(val: (val: string) => void) {
    this.uiOnChange = val
    this.refresh()
  }

  public override render(el: HTMLInputElement): void {
    el.innerHTML = ''
    el.className = 'ui-input'
    el.onchange = (event: Event) => {
      const target = event.target as HTMLInputElement
      this.uiOnChange(target?.value || '')
    }
    super.render(el)
  }
}
